<template>
  <page-layout title="采购订单" class="p-PurchaseOrderList">
    <header class="c-tradingcenter-search-header clearfix">
      <div class="c-tradingcenter-search-header-fl">
        <znl-input
          :border="true"
          v-model="dataTime"
          :height="30"
          date-type="daterange"
          form-type="datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="true"
          class="mr10"
          @change="dataTimeChange"
          ref="dateinput"
          title="下单时间:"
          title-width="60px"
        >
        </znl-input>

        <znl-input
          width="180px"
          :height="30"
          :border="true"
          placeholder="搜索订单编号"
          class="mr10"
          :clearable="true"
          title="订单编号:"
          title-width="60px"
          v-model="OrderNo"
          @clear="
            () => {
              onBindData();
            }
          "
          @keydown.enter="
            () => {
              onBindData();
            }
          "
        >
        </znl-input>

        <znl-input
          width="180px"
          :height="30"
          :border="true"
          placeholder="订单状态"
          class="mr10"
          :clearable="true"
          title="订单状态:"
          title-width="60px"
          v-model="Status"
          form-type="select"
          :select-options="selectOptions"
          @change="selectChange"
        >
        </znl-input>

        <znl-button
          :width="60"
          :height="30"
          style-type="main"
          class="mr10"
          @click="
            () => {
              onBindData();
            }
          "
        >
          <i class="iconfont icon-sousuo"></i>
          搜索
        </znl-button>

        <znl-button :width="60" :height="30" class="mr10" @click="clearParams">
          <i class="iconfont icon-refresh"></i>
          重置
        </znl-button>
      </div>
    </header>
    <div class="p-PurOrderList">
      <div class="p-PurOrderList-body">
        <ul>
          <li class="p-PurOrderList-listtable-header">
            <div class="nativetable">
              <div class="flex-box">
                <div
                  v-for="col in columns.filter((c, i) => i < 7)"
                  :key="col.field"
                  :style="{
                    width: col.width ? `${col.width}px` : '',
                    flex: col.width ? null : 1,
                    minWidth: '60px'
                  }"
                >
                  <div class="cell">{{ col.header }}</div>
                </div>
              </div>
              <div
                v-for="(col, index) in columns.filter((c, i) => i >= 7)"
                :key="col.field"
                :style="{
                  width: col.width ? `${col.width}px` : '',
                  flex: col.width ? null : 1
                }"
              >
                <div class="cell">{{ col.header }}</div>
              </div>
            </div>
          </li>
          <li
            v-for="item in datas"
            :key="item.OrderGuid"
            class="p-PurOrderList-listtable-row"
          >
            <div class="p-PurOrderList-listtable-row-title">
              <span :style="{ marginRight: '20px' }">
                {{ item.CreateTimeStr }}
              </span>
              <span :style="{ marginRight: '40px', marginLeft: '30px' }">
                订单编号：{{ item.OrderNo }}
              </span>
              <span class="pointer" :style="{ marginLeft: '20px' }">
                <!-- <span class="record-list">
                  供应商：{{ item.SupplierName }}
                </span> -->
                <span @click="showQQ">
                  <i class="qqback"></i>
                  在线客服
                </span>
              </span>

              <span class="order-amount pull-right">
                订单金额：
                <span class="color-main font-blod">¥ {{ item.Amount }}</span>
              </span>
            </div>
            <div class="p-PurOrderList-listtable-nativetable">
              <div class="nativetabler-tr">
                <div
                  class="border-right"
                  :style="{
                    width: sumHandler(columns.filter((c, i) => i < 7)) + 'px',
                    flex: 1
                  }"
                >
                  <div
                    v-for="(data, index) in item.Lines"
                    :key="index"
                    :style="{ display: 'flex' }"
                  >
                    <div
                      v-for="col in columns.filter((c, i) => i < 7)"
                      :key="col.field"
                      :style="{
                        width: col.width ? `${col.width}px` : '',
                        flex: col.width ? null : 1,
                        minWidth: '60px'
                      }"
                    >
                      <div class="cell">
                        {{ data[col.field] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="border-right align-items-center"
                  :style="{
                    width: `${columns.find(c => c.field === 'Status').width}px`
                  }"
                >
                  <div class="cell status-cell">
                    <div>
                      {{ getOrderStatus(item.Status) }}
                    </div>
                    <div v-if="item.Status === 1">
                      {{ getOrderCancelMinutesStr(item.OrderCancelMinutes) }}
                    </div>
                    <div
                      class="status-operation"
                      @click="
                        () => {
                          toPurchaseOrderListDetails(item);
                        }
                      "
                    >
                      订单详情
                    </div>
                  </div>
                </div>
                <div
                  class="border-right align-items-center"
                  :style="{
                    width: `${
                      columns.find(c => c.field === 'Operation').width
                    }px`
                  }"
                >
                  <div class="cell operation-cell">
                    <div
                      v-if="item.Status === 1 && item.OrderCancelMinutes > 0"
                    >
                      <znl-button
                        :width="80"
                        :height="26"
                        style-type="main"
                        @click.stop="
                          showWxPayDialog = true;
                          activeOrder = item;
                        "
                      >
                        微信支付
                      </znl-button>
                    </div>
                    <!-- <div
                      v-if="item.Status === 1 && item.OrderCancelMinutes > 0"
                    >
                      <znl-button
                        :width="80"
                        :height="26"
                        style-type="main"
                        @click.stop="
                          showPurPayDialog = true;
                          activeOrder = item;
                        "
                      >
                        上传水单
                      </znl-button>
                    </div> -->
                    <div v-if="item.Status === 4">
                      <znl-button
                        :width="80"
                        :height="26"
                        style-type="main"
                        @click.stop="
                          () => changeOrderStatusAsync(item.OrderGuid, 6)
                        "
                      >
                        确认收货
                      </znl-button>
                    </div>
                    <div v-if="item.Status === 0 || item.Status === 1">
                      <znl-button
                        type="text"
                        @click="
                          () => {
                            cancelOrderHandler(item);
                          }
                        "
                      >
                        取消订单
                      </znl-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="datas.length === 0 && readly" class="empty-data">
          <p>暂无订单</p>
        </div>
        <div class="p-orderlist-pagination clearfix">
          <el-pagination
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalCount"
            class="pull-right"
            :small="true"
            :current-page.sync="pageIndex"
            @current-change="onBindData"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <WxPayDialog
      :visible.sync="showWxPayDialog"
      :order="activeOrder"
      :onBindData="onBindData"
    ></WxPayDialog>
    <!-- <PurPayDialog
      :visible.sync="showPurPayDialog"
      :submit="submit"
      :onBindData="onBindData"
      :order="activeOrder"
    ></PurPayDialog> -->
  </page-layout>
</template>
<script>
import { httpPost } from '../../assets/scripts/http';
import TradingStore from '../../store';
import PageLayout from '../PageLayout';
import WxPayDialog from './WxPayDialog';
// import PurPayDialog from './PurPayDialog';
export default {
  name: 'PurOrderList',
  props: {
    ordertype: {
      type: String,
      default: ''
    }
  },
  components: {
    PageLayout,
    WxPayDialog
    // PurPayDialog
  },
  data() {
    return {
      store: TradingStore,
      readly: false,
      columns: [
        {
          field: 'PartNo',
          width: 200,
          header: '型号'
        },
        {
          field: 'Brand',
          width: 150,
          header: '品牌'
        },
        {
          field: 'Package',
          width: 150,
          header: '封装'
        },
        {
          field: 'MakeYear',
          width: 150,
          header: '年份'
        },
        {
          field: 'Qty',
          width: 0,
          header: '数量'
        },
        {
          field: 'Price',
          width: 0,
          header: '单价'
        },
        {
          field: 'Amount',
          width: 0,
          header: '金额'
        },
        {
          field: 'Status',
          width: 150,
          header: '状态'
        },
        {
          field: 'Operation',
          width: 150,
          header: '操作'
        }
      ],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 1,
      datas: [],
      dataTime: ['', ''],
      OrderNo: '',
      Status: '',
      // 0:待确认，1:待支付，2:审核中，3:待发货，4:待收货，5:已取消，6:完成
      selectOptions: [
        { key: '', value: '全部' },
        // { key: 0, value: '待确认' },
        { key: 1, value: '待支付' },
        { key: 2, value: '审核中' },
        { key: 3, value: '待发货' },
        { key: 4, value: '已发货' },
        { key: 5, value: '已取消' },
        { key: 6, value: '已完成' }
      ],
      showWxPayDialog: false,
      // showPurPayDialog: false,
      activeOrder: {}
    };
  },
  created() {
    this.onBindData();
    this.readly = false;
  },
  methods: {
    getOrderStatus(status) {
      let statusStr = '';
      switch (status) {
        // case 0:
        //   statusStr = '待确认';
        //   break;
        case 1:
          statusStr = '待支付';
          break;
        case 2:
          statusStr = '支付审核中';
          break;
        case 3:
          statusStr = '待发货';
          break;
        case 4:
          statusStr = '已发货';
          break;
        case 5:
          statusStr = '已取消';
          break;
        case 6:
          statusStr = '已完成';
          break;
        default:
          break;
      }
      return statusStr;
    },
    getOrderCancelMinutesStr(minutes) {
      let ms = minutes;
      if (!ms) {
        return '';
      }
      if (ms < -1) {
        ms = 0;
      }
      // 天
      let day = 0;
      if (ms > 24 * 60) {
        day = Math.floor(ms / (24 * 60));
        ms -= day * 24 * 60;
      }
      // 时
      let hour = 0;
      if (ms > 60) {
        hour = Math.floor(ms / 60);
        ms -= hour * 60;
      }
      return `${day}天 ${hour}时 ${ms}分`;
    },
    sumHandler(items) {
      let num = 0;
      items.forEach(item => {
        num += item.width;
      });
      return num;
    },
    selectChange(value) {
      this.Status = value ? value.key : 0;
      this.onBindData();
    },
    dataTimeChange(value) {
      this.dataTime = value ? value : ['', ''];
      this.onBindData();
    },
    onBindData(PageIndex = 1) {
      this.loading = true;
      this.readly = true;
      this.dataTime = this.dataTime ? this.dataTime : ['', ''];
      httpPost('bomorder/getOrderList', {
        OrderNo: this.OrderNo,
        Status: this.Status,
        CreateTimeStart: this.dataTime[0],
        CreateTimeEnd: this.dataTime[1],
        PageIndex,
        PageSize: this.pageSize
      }).then(res => {
        this.loading = false;
        if (res.Code === 0) {
          const DATAS = res.Data.ResultList || [];
          DATAS.forEach(item => {
            item.RemarkOrderHistory = '';
            item.RemarkIsEdit = false;
            item.RemarkEditInputValue = '';
          });
          this.pageIndex = res.Data.PageIndex || 1;
          this.totalCount = res.Data.TotalCount || 1;
          DATAS.forEach((item, index) => (item.ID = index));
          this.datas = DATAS;
        }
      });
    },
    clearParams() {
      this.$refs.dateinput.clear();
      this.OrderNo = '';
      this.dataTime = ['', ''];
      this.Status = '';
      this.onBindData();
    },
    // 上传水单
    async submit(url) {
      try {
        const res = await httpPost('bomorder/changeOrderStatusAsync', {
          PayUrl: url,
          OrderGuid: this.activeOrder.OrderGuid,
          AfterStaus: 2
        });
        if (res.Code === 0) {
          return true;
        } else {
          this.$erroMess(res.Message);
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPurchaseOrderListDetails(data) {
      this.store.commit('setRoute', {
        name: 'PurchaseOrderListDetails',
        params: { id: data.OrderGuid }
      });
    },
    // 修改订单状态
    changeOrderStatusAsync(OrderGuid, AfterStaus) {
      httpPost('bomorder/changeOrderStatusAsync', {
        OrderGuid,
        AfterStaus
      }).then(res => {
        if (res.Code === 0) {
          this.onBindData();
        } else {
          this.$erroMess(res.Message);
        }
      });
    },
    // 取消订单
    cancelOrderHandler(order) {
      this.$confirm('确定取消订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.changeOrderStatusAsync(order.OrderGuid, 5);
        })
        .catch(err => {
          console.log(err);
        });
    },
    showQQ() {
      window.open(
        'http://wpa.qq.com/msgrd?v=3&uin=2243731620&site=qq&menu=yes',
        '_brank'
      );
    }
  }
};
</script>
<style lang="scss">
.p-PurchaseOrderList {
  .mr10 {
    margin-right: 10px;
  }
  .qqback {
    display: inline-block;
    width: 19px;
    height: 18px;
    background-repeat: no-repeat;
    background: url(../../assets/imgs/bomIcon.png);
    background-position: -447px -28px;
    position: relative;
    top: 4px;
  }
  .p-PurOrderList {
    font-size: 12px;
    min-width: 1130px;
    .pointer {
      cursor: pointer;
    }
    .color-red {
      color: #ee4f00;
    }
    .color-main {
      color: #ee7700;
    }
    .font-blod {
      font-weight: bold;
      font-size: 14px;
    }
    .font-blod-12 {
      font-weight: bold;
      font-size: 12px;
    }

    .cell {
      box-sizing: border-box;
      padding-left: 10px;
      .quality {
        line-height: 30px;
        padding-left: 10px;
      }
      &.status-cell {
        text-align: center;
        box-sizing: border-box;
        color: $--fontcolor-dark-3;
        .status-operation {
          cursor: pointer;
        }
      }
      &.operation-cell {
        text-align: center;
        padding: 0 5px;
      }
    }
    .p-PurOrderList-listtable-row {
      border-bottom: 1px solid #e6e6e6;
      font-size: 12px;
      background-color: #fff;
      .border-right {
        border-right: 1px solid #e6e6e6;
      }
      .align-items-center {
        display: flex;
        align-items: center;
        text-align: left;
        justify-content: center;
      }
      .p-PurOrderList-listtable-nativetable {
        border-collapse: collapse;
        line-height: 30px;
        width: 100%;
        .nativetabler-tr {
          display: flex;
          width: 100%;
          min-height: 100px;
        }
      }
    }
    .p-PurOrderList-listtable-row-title {
      line-height: 30px;
      background-color: #ebebeb;
      margin-top: 10px;
      font-size: 12px;
      color: $--fontcolor-dark-2;
      position: relative;
      padding: 0 10px;
    }
    .p-PurOrderList-listtable-header {
      background-color: #e6f0fa;
      .nativetable {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        .flex-box {
          display: flex;
          flex: 1;
          width: 100%;
        }
      }
    }
    .p-orderlist-pagination {
      padding: 5px 0;
      .el-pagination {
        button {
          background: transparent;

          &:disabled {
            background: transparent;
          }
        }
        .el-pager {
          li {
            background: transparent;
            &.active {
              background: #808080;
              color: #fff;
            }
          }
        }
      }
    }
    .empty-data {
      text-align: center;
      p {
        color: #808080;
        font-size: 14px;
        padding-bottom: 20px;
      }
    }
  }
}
</style>
